// extracted by mini-css-extract-plugin
export default {"section":"SidebarSection_section__QS2j8","sectionLabel":"SidebarSection_sectionLabel__kOL+S","sectionBody":"SidebarSection_sectionBody__3RiR0"};